import React, { Suspense } from 'react'
import { FIELD_TYPES_MAP } from '../../common/constants'
import { isBrowser, isTablet } from 'react-device-detect'
import Field from '../fields'
import { IconSectionHeader } from '../generic'

interface FormFieldsProps {
  form: {
    formFields: {
      type: string
      keys?: string
      label: string
    }[]
    id: string
  }
  fields?: Record<string, any>
  formId?: string
  readOnly?: boolean
  noLeftMargin?: boolean
  style?: React.CSSProperties
  userGenerated?: boolean
}

const FormFields: React.FC<FormFieldsProps> = ({
  form,
  fields,
  formId = 'createRiskAssessment',
  readOnly,
  noLeftMargin = false,
  style,
  userGenerated = false,
}) => {
  if (!fields) return null

  return (
    <div style={style}>
      {form.formFields.map((field, index) => {
        if (field.type === 'header') {
          return (
            <Header
              noLeftMargin={noLeftMargin}
              key={field.keys}
              label={field.label}
            />
          )
        }
        return (
          <div key={field.keys || field.label} style={{ paddingTop: 16 }}>
            <Suspense fallback={<div>Loading...</div>}>
              <Field
                {...field}
                form_id={form.id}
                formId={formId}
                // @ts-ignore
                fieldType={FIELD_TYPES_MAP[field.type] || field.type}
                readOnly={readOnly}
                values={fields}
                {...getAdditionalProps(userGenerated, field.type)}
              />
            </Suspense>
          </div>
        )
      })}
    </div>
  )
}

interface HeaderProps {
  label: string
  noLeftMargin?: boolean
}

const Header: React.FC<HeaderProps> = ({ label, noLeftMargin = false }) => (
  <div
    style={{
      marginLeft: !noLeftMargin && isDesktop ? 55 : 0,
      ...styles.header,
    }}
  >
    <IconSectionHeader title={label} />
  </div>
)

const getAdditionalProps = (userGenerated: boolean, type: string) => {
  const additionalProps: Record<string, any> = {}
  if (userGenerated) {
    additionalProps.type = FIELD_IDS.includes(type) ? type : FIELD_ID
  }
  return additionalProps
}

const FIELD_ID = 'userGeneratedFieldLayout'
const FIELD_IDS = ['bmiCalculation', 'riskCalculation']

const isDesktop = isBrowser || isTablet

const styles = {
  header: {
    marginTop: 35,
  },
}

export default FormFields
